var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimCardBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 92,
    viewBox: "0 0 335 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16245_29767)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 92,
    fill: "#CCDDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 117,
    r: 57,
    fill: "#BAD0FD"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 128,
    cy: 20,
    r: 57,
    fill: "#BAD0FD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.838 8.274L250.92 15.1252C239.057 17.2216 231.047 28.4269 232.909 40.3264L243.941 101.384C245.855 113.474 257.204 121.729 269.296 119.821C269.472 119.789 269.644 119.764 269.82 119.726L315.352 111.499C327.199 108.858 334.822 97.299 332.578 85.3685L323.139 33.128L288.838 8.274Z",
    stroke: "#1F65EC",
    strokeWidth: 8.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.331 8.48438L290.327 25.0639C291.789 33.157 299.517 38.5348 307.614 37.0953L323.316 34.2582",
    stroke: "#1F65EC",
    strokeWidth: 8.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.248 80.5232L268.471 86.0841",
    stroke: "#1F65EC",
    strokeWidth: 8.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.73 61.2492L264.603 64.7052",
    stroke: "#1F65EC",
    strokeWidth: 8.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16245_29767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimCardBg);
export default __webpack_public_path__ + "static/media/claimCardBg.a9b5c654b69bdc0cb6ef7574fc6e88b9.svg";
export { ForwardRef as ReactComponent };